import { Loader } from "lucide-react";
import { useState } from "react";
import {
  FiChevronDown,
  FiChevronRight,
  FiFile,
  FiFolder,
} from "react-icons/fi";

const RenderItemsTree = ({
  items,
  navigateToFolder,
  currentParentId,
  currentFolderId,
  toggleFolder,
  expandedFolderTree,
  isLoadingTree,
}) => {
  const currentItems = items.filter((item) => {
    if (item.type === "folder") {
      return item.parentFolderId === currentParentId;
    } 
    else {
      return item.folderId === currentParentId;
    }
  });

  const [expandedFolders, setExpandedFolders] = useState({});
  
  const handleChevronClick = (e, folderId) => {
    e.stopPropagation();
    
    setExpandedFolders(prev => ({
      ...prev,
      [folderId]: !prev[folderId]
    }));
    
    if (!expandedFolders[folderId]) {
      toggleFolder(folderId);
    }
  };

  return (
    <>
      {currentItems.map((item) => {
        const isItemExpanded = expandedFolders[item._id] || false;
        
        return (
          <div key={item._id} className="ml-4">
            <div
              className={`flex items-center py-1 cursor-pointer hover:bg-gray-100 ${
                currentFolderId === item._id ? "bg-blue-50" : ""
              }`}
              onClick={
                item.type === "folder" ? () => toggleFolder(item._id) : () => {}
              }
            >
              {item.type === "folder" && (
                <span
                  className="mr-1 text-gray-500 cursor-pointer"
                  onClick={(e) => handleChevronClick(e, item._id)}
                >
                  {isItemExpanded ? (
                    <FiChevronDown size={14} />
                  ) : (
                    <FiChevronRight size={14} />
                  )}
                </span>
              )}
              <>
                {item.type === "folder" ? (
                  <>
                    <FiFolder className="text-blue-500 mr-1" size={16} />
                    <span className="text-sm truncate">{item.folderName}</span>
                  </>
                ) : (
                  <>
                    <FiFile className="text-blue-500 mr-1" size={16} />
                    <span className="text-sm truncate">{item.title}</span>
                  </>
                )}
                {isLoadingTree && expandedFolders[item._id] && (
                  <Loader size={15} className="ml-2 animate-spin" />
                )}
              </>
            </div>

            {isItemExpanded && item.type === "folder" && (
              <RenderItemsTree
                items={items}
                navigateToFolder={navigateToFolder}
                currentParentId={item._id}
                toggleFolder={toggleFolder}
                expandedFolderTree={expandedFolderTree}
                isLoadingTree={isLoadingTree}
                currentFolderId={currentFolderId}
              />
            )}
          </div>
        );
      })}
    </>
  );
};

export default RenderItemsTree;